// src/api_scripts/getaddressbookList.js
import { fetchAllPages } from "../paginationUtils";

const getaddressbookList = async (addressbookListName, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v3/address-book`;

  try {
    const dataArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Address Books");
    console.log("Get Address Book API Response Data (all pages):", dataArray.length, "items");
    return dataArray;

  } catch (error) {
    console.error(`Error fetching Address Books:`, error);
    throw error;
  }
};

export default getaddressbookList;